export {
    FETCH_YOURSELF,
    PROMOZAVR_MODEL,
    PROMOZAVR_PERSISTENT_PROJECT,
    PROMOZAVR_PERSISTENT_QUEUE,
    PROMOZAVR_PERSISTENT_TOUCH_PROJECT,
    PROMOZAVR_PROJECT,
    PROMOZAVR_QUEUE_KINDS,
    PROMOZAVR_REGULAR_QUEUE,
    PROMOZAVR_SELECT_MULTIPLE_PROMOS_MODEL,
    PROMOZAVR_STAGE,
    PROMOZAVR_TOUCH_PROJECT,
    type PromozavrProject,
    type PromozavrRendererSource,
    type PromozavrQueueKind,
    type PromozavrQueueSelection,
    type PromozavrQueueSelections,
    type PromozavrState,
    type PromozavrStatus,
    type SelectMultiplePromosModelInput,
    type SelectMultiplePromosModelResponse,
    type SelectMultiplePromosModelServerInput,
    type SelectPromoModelInput,
    type SelectPromoModelResponse,
    type SelectPromoSuppliersData,
} from '../../../../../common/helpers/promozavr/types/promozavr';

export type InitPromozavrPayload = {
    pathname: string;
    search: string;
    requestKey: string;
};
